<script setup lang="ts">
/**
 * Interactive tutorials — the shared shell behind the Welcome and Completion
 * cards: a 440px panel centred over a full scrim (handoff README §1 and §6).
 *
 * The progress pills — one per big step — are part of the shell rather than of
 * each card, because both cards show the same run's steps and reading them off
 * the tour's own `steps` array is what keeps a second tutorial, of whatever
 * length, from needing a second modal.
 */

defineProps<{
  eyebrow: string
  title: string
  /** Big-step names; one pill each. */
  steps: string[]
  /** Index of the pill drawn in clay — 0 on Welcome, past the end on Done. */
  currentStep: number
}>()
</script>

<template>
  <div class="tour-modal">
    <div class="tour-modal__scrim" />
    <div class="tour-modal__panel" role="dialog" aria-modal="true">
      <span class="bz-eyebrow">{{ eyebrow }}</span>
      <h2 class="tour-modal__title">{{ title }}</h2>

      <slot />

      <div class="tour-dots tour-dots--modal">
        <i
          v-for="(_, k) in steps"
          :key="k"
          :class="{ done: k < currentStep, on: k === currentStep }"
        />
      </div>

      <div class="tour-modal__foot">
        <slot name="foot" />
      </div>
    </div>
  </div>
</template>
